// Keep in sync with personnel-order-service/src/functions/sendMail/attachmentLimits.ts
export const MAX_ATTACHMENTS = 1;
export const MAX_TOTAL_ATTACHMENT_BYTES = 4 * 1024 * 1024;

export const ALLOWED_MIME_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png',
] as const;

export const ALLOWED_FILE_EXTENSIONS = '.pdf,.doc,.docx,.jpg,.jpeg,.png';
